
const FeedbackList = () => {
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-[#F9F6F1] to-[#F5E6D3]">
      <div className="max-w-6xl mx-auto">
        {/* Salvation: It's Not What I Thought It Was (First) */}
        <div className="mb-20">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3A52] mb-3">
              Salvation: It's Not What I Thought It Was
            </h2>
            <p className="text-lg text-[#D4AF37] font-semibold">Volume I</p>
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-10 shadow-2xl border-t-4 border-[#D4AF37]">
            <div className="flex items-start gap-6 mb-6">
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#D4AF37] to-[#C4A137] rounded-full flex-shrink-0">
                <i className="ri-heart-3-fill text-2xl text-white"></i>
              </div>
              <div className="flex-1 space-y-5 text-gray-700 text-base leading-relaxed">
                <p>
                  Reading this book felt like sitting down with a wise, no-nonsense pastor who's been through the highs and lows of faith, and isn't afraid to talk about either. If you've ever wondered, <span className="font-bold italic text-[#1B3A52]">"Is this really going to do the Christian life?"</span> after hearing the sinner's prayer week after week, this book will speak to you.
                </p>
                <p>
                  Don R. Vining doesn't sugarcoat things. He gently but directly points out how easy it is to settle for a surface-level version of Christianity, something that looks right on the outside but leaves us feeling empty or stuck inside. What he offers instead is a deeper, more honest path: one that involves change, hard conversations with God, and difficult people (including ourselves).
                </p>
                <p>
                  I appreciated how practical it was. He talks about things like how to forgive others (even the ones that hurt us the most), how to recognize if we're givers or takers, how to pray with sincerity, not just habit, and how grace isn't just a concept, it's a way of living.
                </p>
                <p>
                  What I found most encouraging is that he makes room for struggle. This isn't a "just believe harder" type message. It's an invitation to walk daily with Christ, knowing it's a journey, not a performance.
                </p>
                <p>
                  This book gave me hope and perspective, and honestly, a bit of a spiritual reset. If you're feeling spiritually tired, jaded, or just hungry for something real, <span className="font-bold italic text-[#1B3A52]">Salvation: It's Not What I Thought It Was</span> might be just what you need.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="py-10">
          <div className="flex items-center gap-6">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
            <div className="text-4xl text-[#D4AF37]">
              <i className="ri-book-open-fill"></i>
            </div>
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
          </div>
        </div>

        {/* Volume II: Souls Under Siege */}
        <div className="mb-20">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3A52] mb-3">
              Souls Under Siege
            </h2>
            <p className="text-lg text-[#D4AF37] font-semibold">Volume II</p>
          </div>

          <div className="bg-gradient-to-br from-white to-[#F9F6F1] rounded-3xl p-8 md:p-10 shadow-2xl border-t-4 border-[#1B3A52]">
            <div className="flex items-start gap-6 mb-6">
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#1B3A52] to-[#2A4A62] rounded-full flex-shrink-0">
                <i className="ri-shield-cross-fill text-2xl text-[#D4AF37]"></i>
              </div>
              <div className="flex-1 space-y-5 text-gray-700 text-base leading-relaxed">
                <p>
                  I found <span className="font-bold italic text-[#1B3A52]">Souls Under Siege</span> to be a really eye-opening and timely book. Pastor Don Vining does a great job reminding us that we're still in a spiritual battle, something that many churches seem to have forgotten. I really appreciated the message, but it's definitely more than just making an emotional decision at the altar and someone truly being converted. That part really stood out to me.
                </p>
                <p>
                  The book challenged me to think about how we, as believers, can do more than just invite people to church; we need to walk with them, disciple them, and be willing to step into the hard parts of ministry, even when it's inconvenient. It's not always a comfortable message, but it's definitely one the Church needs to hear right now.
                </p>
                <p>
                  Overall, I think this book is a solid reminder of what our mission really is. It stirred something in me and made me want to be more intentional about how I support and follow up with others in their faith journey.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="py-10">
          <div className="flex items-center gap-6">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
            <div className="text-4xl text-[#D4AF37]">
              <i className="ri-book-open-fill"></i>
            </div>
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
          </div>
        </div>

        {/* Volume III: Don't Let the Rocks Cry Out! */}
        <div className="mb-20">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3A52] mb-3">
              Don't Let the Rocks Cry Out!
            </h2>
            <p className="text-lg text-[#D4AF37] font-semibold">Volume III</p>
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-10 shadow-2xl border-t-4 border-[#D4AF37]">
            <div className="flex items-start gap-6 mb-6">
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#1B3A52] to-[#2A4A62] rounded-full flex-shrink-0">
                <i className="ri-double-quotes-l text-2xl text-[#D4AF37]"></i>
              </div>
              <div className="flex-1 space-y-5 text-gray-700 text-base leading-relaxed">
                <p>
                  What stands out to me about <span className="font-bold italic text-[#1B3A52]">Don't Let the Rocks Cry Out!</span> is its bold yet approachable invitation to authentic worship. Pastor Don Vining isn't trying to sell a style of worship; he's pointing readers back to the heart of it: responding to God's greatness with freedom, passion, and sincerity.
                </p>
                <p>
                  I really like that the book speaks to people who may feel spiritually restless in worship, those who long for something deeper but feel held back by tradition, fear, or habit. The reference to Jesus' words about the rocks crying out adds weight to the message: worship isn't just a ritual; it's a necessary response to who God is.
                </p>
                <p>
                  Vining's no-nonsense, encouraging tone helps break down barriers. He doesn't guilt readers into worship; he invites them into a fuller experience of it. Whether someone is expressive or quiet by nature, the book seems to say: there's a place for your voice in God's presence, and it matters.
                </p>
                <p>
                  Overall, I'd say it's a refreshing and empowering read, especially for believers who feel like they're just "going through the motions" in church. It reminds us that worship is personal, and powerful, and should reflect our hearts before or alongside anyone else.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="py-10">
          <div className="flex items-center gap-6">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
            <div className="text-4xl text-[#D4AF37]">
              <i className="ri-book-open-fill"></i>
            </div>
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
          </div>
        </div>

        {/* Volume IV: His Pain, My Gain */}
        <div className="mb-20">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3A52] mb-3">
              His Pain, My Gain
            </h2>
            <p className="text-lg text-[#D4AF37] font-semibold">Volume IV</p>
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-10 shadow-2xl border-t-4 border-[#D4AF37]">
            <div className="flex items-start gap-6 mb-6">
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#D4AF37] to-[#C4A137] rounded-full flex-shrink-0">
                <i className="ri-cross-fill text-2xl text-white"></i>
              </div>
              <div className="flex-1 space-y-5 text-gray-700 text-base leading-relaxed">
                <p>
                  <span className="font-bold italic text-[#1B3A52]">His Pain, My Gain</span> is a deeply moving and theologically rich work that challenges readers to look beyond the surface of Christ's suffering and recognize its transformative power in our daily lives. He endured on the way to the cross. Pastor Don R. Vining skillfully takes what many of us tend to view as a distant historical event and makes it intensely personal and relevant. Rather than preaching suffering as a distant theological reality, Pastor Vining reveals how sacrifice opens the door for life, healing, and victory in every believer's walk with Christ.
                </p>
                <p>
                  The book's greatest strength lies in its ability to connect the seven moments of Christ's bleeding with the real struggles and circumstances believers face today. Rather than presenting suffering as a distant theological reality, Pastor Vining reveals how each sacrifice opens the door for life, healing, and victory in every believer's walk with Christ. The writing is clear, pastoral, and filled with compassion, making complex theological truths accessible without losing their authority or depth. Throughout the pages, his voice carries both the authority of Scripture and the heart of a shepherd, reminding readers that they are spiritually challenged and encouraged to go deeper in their relationship with Christ.
                </p>
                <p>
                  This book is more than just a study of Christ's suffering—it is an invitation to experience the power of His blood in a personal way. <span className="font-bold italic text-[#1B3A52]">His Pain, My Gain</span> will inspire believers to embrace the fullness of Christ's redemption and walk in the victory He has already secured.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="py-10">
          <div className="flex items-center gap-6">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
            <div className="text-4xl text-[#D4AF37]">
              <i className="ri-book-open-fill"></i>
            </div>
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
          </div>
        </div>

        {/* Volume V: Poison in the Pot */}
        <div className="mb-20">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3A52] mb-3">
              Poison in the Pot
            </h2>
            <p className="text-lg text-[#D4AF37] font-semibold">Volume V</p>
          </div>

          <div className="bg-gradient-to-br from-white to-[#F9F6F1] rounded-3xl p-8 md:p-10 shadow-2xl border-t-4 border-[#1B3A52]">
            <div className="flex items-start gap-6 mb-6">
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#1B3A52] to-[#2A4A62] rounded-full flex-shrink-0">
                <i className="ri-flask-fill text-2xl text-[#D4AF37]"></i>
              </div>
              <div className="flex-1 space-y-5 text-gray-700 text-base leading-relaxed">
                <p>
                  What I appreciate about <span className="font-bold italic text-[#1B3A52]">Poison in the Pot</span> is its clarity of purpose and its honest, no-frills approach to spiritual growth. Pastor Don Vining doesn't just talk about vague spiritual struggles; he helps readers identify specific "poisons" that can quietly damage our lives, homes, and churches. The book emphasizes personal responsibility and spiritual self-examination, encouraging readers to be totally honest with themselves about the hard, necessary questions about sin, hurt, leadership, and witness in the workplace. I also value the book's practical focus; rather than staying in theory, it offers a real-world guide to spiritual cleansing, whether that means removing harmful influences or inviting the Holy Spirit to do deeper work. Most of all, there's a sincere pastoral heart behind the writing. Vining wants to see people transformed, not just informed. That urgency and compassion give the book weight and purpose.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="py-10">
          <div className="flex items-center gap-6">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
            <div className="text-4xl text-[#D4AF37]">
              <i className="ri-book-open-fill"></i>
            </div>
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
          </div>
        </div>

        {/* Volume VI: Lucifer Did Me a Favor */}
        <div className="mb-20">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3A52] mb-3">
              Lucifer Did Me a Favor
            </h2>
            <p className="text-lg text-[#D4AF37] font-semibold">Volume VI</p>
          </div>

          <div className="bg-gradient-to-br from-[#1B3A52] to-[#2A4A62] rounded-3xl p-8 md:p-10 shadow-2xl border-t-4 border-[#D4AF37]">
            <div className="flex items-start gap-6 mb-6">
              <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37] rounded-full flex-shrink-0">
                <i className="ri-lightbulb-flash-fill text-2xl text-[#1B3A52]"></i>
              </div>
              <div className="flex-1 space-y-5 text-[#F5E6D3] text-base leading-relaxed">
                <p>
                  Your book, <span className="font-bold italic text-[#D4AF37]">Lucifer Did Me a Favor</span>, offers a refreshing and powerful perspective on worship and spiritual purpose. What I like most is how it flips the traditional view of Lucifer's fall, presenting it not only as a tragedy but an opportunity for humankind to step into a higher calling. That idea, that we were given the privilege to worship in Lucifer's place, feels both humbling and empowering. It makes the reader stop and reflect on worship not as a ritual or habit, but as a sacred responsibility and honor.
                </p>
                <p>
                  Another strength of your writing is the passion and conviction that comes through on every page. The way you connect scripture, personal experiences, and practical illustrations keeps your teaching relatable while still being deeply theological. For example, the imagery of worship as something that can tunnel through life's mountains is incredibly moving; it gives readers both hope and a concrete way to see how worship can transform their lives. This combination of biblical insight and everyday examples makes the message accessible to a wide range of readers.
                </p>
                <p>
                  Finally, I really appreciate how you continually shift the focus back to God Himself rather than simply what He can do for us. You challenge readers to worship not out of convenience, fear, or personal gain, but simply because He is worthy. That emphasis on authentic worship over superficial religion is a message many people need to hear today. It makes the book not just instructional, but also transformational, a call to live differently and to understand that worship is the very heartbeat of our relationship with God.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="py-10">
          <div className="flex items-center gap-6">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
            <div className="text-4xl text-[#D4AF37]">
              <i className="ri-book-open-fill"></i>
            </div>
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
          </div>
        </div>

        {/* Volume VII: How to Identify with Your Calling!! */}
        <div className="mb-20">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3A52] mb-3">
              Discovering The Life You Were Created For!
            </h2>
            <p className="text-lg text-[#D4AF37] font-semibold">Volume VII</p>
          </div>

          <div className="bg-gradient-to-br from-white to-[#F9F6F1] rounded-3xl p-8 md:p-10 shadow-2xl border-t-4 border-[#1B3A52]">
            {/* Overall Impression */}
            <div className="mb-10 pb-10 border-b-2 border-[#D4AF37]/30">
              <div className="flex items-start gap-6">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#D4AF37] to-[#C4A137] rounded-full flex-shrink-0">
                  <i className="ri-star-fill text-2xl text-white"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-[#1B3A52] mb-4">Overall Impression</h3>
                  <p className="text-gray-700 text-base leading-relaxed">
                    A heartfelt and faith-driven reflection on calling, perseverance, and divine purpose. Blending Scripture, life experience, and spiritual insight, the author's sincerity and transparency make this work deeply relatable and inspiring.
                  </p>
                </div>
              </div>
            </div>

            {/* Strengths */}
            <div className="mb-10 pb-10 border-b-2 border-[#D4AF37]/30">
              <div className="flex items-start gap-6">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#1B3A52] to-[#2A4A62] rounded-full flex-shrink-0">
                  <i className="ri-thumb-up-fill text-2xl text-[#D4AF37]"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-[#1B3A52] mb-6">Strengths</h3>
                  <div className="space-y-5">
                    <div className="flex items-start gap-4">
                      <div className="w-2 h-2 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700 text-base leading-relaxed">
                        <span className="font-bold text-[#1B3A52]">Authenticity:</span> Honest storytelling reveals both triumphs and struggles, encouraging readers to reflect on their own faith journey.
                      </p>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="w-2 h-2 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700 text-base leading-relaxed">
                        <span className="font-bold text-[#1B3A52]">Biblical Depth:</span> Strong scriptural grounding provides theological clarity and spiritual nourishment, reinforcing the message of divine calling.
                      </p>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="w-2 h-2 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700 text-base leading-relaxed">
                        <span className="font-bold text-[#1B3A52]">Engaging Narrative:</span> Vivid personal stories—with humor and humility—balance the book's spiritual weight and broaden its appeal.
                      </p>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="w-2 h-2 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700 text-base leading-relaxed">
                        <span className="font-bold text-[#1B3A52]">Encouragement:</span> The central message of God's enduring call inspires resilience and trust in His plan.
                      </p>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="w-2 h-2 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700 text-base leading-relaxed">
                        <span className="font-bold text-[#1B3A52]">Clarity of Voice:</span> A warm, pastoral tone gives the book both wisdom and approachability, like learning from a trusted mentor.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Conclusion */}
            <div>
              <div className="flex items-start gap-6">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#1B3A52] to-[#2A4A62] rounded-full flex-shrink-0">
                  <i className="ri-check-double-fill text-2xl text-[#D4AF37]"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-[#1B3A52] mb-4">Conclusion</h3>
                  <p className="text-gray-700 text-base leading-relaxed">
                    <span className="font-bold italic text-[#1B3A52]">"Discovering The Life You Were Created For!"</span> is a powerful guide for anyone seeking purpose through faith. Its blend of biblical truth, testimony, and encouragement makes it both inspirational and deeply human.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-24 text-center bg-gradient-to-br from-[#D4AF37] to-[#C4A137] rounded-3xl p-12 shadow-2xl">
          <div className="w-20 h-20 flex items-center justify-center bg-white rounded-full mx-auto mb-6">
            <i className="ri-quill-pen-fill text-4xl text-[#1B3A52]"></i>
          </div>
          <h3 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3A52] mb-4">
            Share Your Testimony
          </h3>
          <p className="text-[#1B3A52] text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
            Has Pastor Don's writing impacted your spiritual journey? We'd love to hear your story and how these books have transformed your walk with God.
          </p>
          <a
            href="/contact"
            className="inline-block bg-[#1B3A52] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#2A4A62] transition-all whitespace-nowrap cursor-pointer shadow-lg hover:scale-105"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default FeedbackList;
